var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.13916 13.8611H7.20444L16.6787 4.38675C17.0846 3.97993 17.3125 3.42875 17.3125 2.85411C17.3125 2.27948 17.0846 1.7283 16.6787 1.32147C16.266 0.926957 15.7171 0.706787 15.1461 0.706787C14.5752 0.706787 14.0262 0.926957 13.6135 1.32147L4.13916 10.7958V13.8611ZM5.52805 11.3708L14.5954 2.30342C14.7437 2.16172 14.941 2.08265 15.1461 2.08265C15.3512 2.08265 15.5485 2.16172 15.6968 2.30342C15.8426 2.44961 15.9245 2.64765 15.9245 2.85411C15.9245 3.06058 15.8426 3.25862 15.6968 3.40481L6.62944 12.4722H5.52805V11.3708Z",
    fill: "#57689F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.0702 5.9598L15.9445 7.0855V11.7779H11.7779V15.9445H2.05564V2.75008C2.05564 2.5659 2.1288 2.38927 2.25903 2.25903C2.38927 2.1288 2.5659 2.05564 2.75008 2.05564H10.9154L12.0411 0.929943C12.1424 0.835931 12.2493 0.748044 12.3612 0.666748L2.75008 0.666748C2.19755 0.666748 1.66764 0.886241 1.27694 1.27694C0.886241 1.66764 0.666748 2.19755 0.666748 2.75008L0.666748 17.3334H13.4542L17.3334 13.4542V5.63966C17.2519 5.75138 17.1641 5.85827 17.0702 5.9598ZM13.1667 15.657V13.1667H15.657L13.1667 15.657Z",
    fill: "#57689F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDoc);
export default __webpack_public_path__ + "static/media/edit_doc.2c91713a1dbc502f58425439076d82c1.svg";
export { ForwardRef as ReactComponent };